import { Outlet } from "react-router-dom";
import NotFoundPage from "../../../features/fallbacks/NotFoundPage";
import PasswordPage from "../pages/PasswordPage";
import SubscriptionSettingsPage from "../pages/SubscriptionSettingsPage";
import ProfileInformation from "../components/ProfileInformation";

export const ProfileRoutes = [
  {
    path: "/",
    element: <Outlet />,
    children: [
      {
        path: ``,
        element: <ProfileInformation />,
      },
      {
        path: `password-settings`,
        element: <PasswordPage />,
      },
      {
        path: `subscription-settings`,
        element: <SubscriptionSettingsPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];
